import { useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ServiceConfig } from '@user/store/services/config'
import { useQuery } from 'react-query'
import { get } from '@user/store/services/crud'
import { IImport } from '@user/store/import/typings'
import { selectImportFilters, setAll } from '@user/store/import/slice'
import { useSelector } from 'react-redux'
import buildQuery from 'odata-query'

export function useLongPolling() {
  const odataUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.odata}`
  const { filterSet, page, perPage } = useSelector(selectImportFilters)
  const { orderBy } = filterSet

  const { data, isFetching, refetch } = useQuery(['importList'], async () => {
    const qString = buildQuery<IImport>({
      skip: (page - 1) * perPage,
      top: perPage,
      count: page === 1,
      orderBy: orderBy,
    })

    const result = await get(`${odataUrl}${qString}`)
    if (result instanceof Response && result.ok) {
      const response = await result.json()

      return response.value as IImport[]
    }
  })

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 5000)
    return () => clearInterval(interval)
  })

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isFetching && data && data.length > 0) dispatch(setAll(data))
  }, [data, dispatch, isFetching])
}
